import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import {ROLE_EXTERNAL_ADMIN} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetSeedTicketTypeList = (seriesIdx) => {
	const [fetchResult, fetchRequest] = useFetch()
	const [userRole] = useRoleCookie()
	const [, setAlert] = useAlertModalAtom()
	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/series/${seriesIdx}/seed-ticket-type/list`

		seriesIdx && fetchRequest('GET', url)
	}, [seriesIdx])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'series_idx')
					setAlert('대회 시리즈 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 시리즈 데이터가 존재하지 않습니다.')
				break
		}
	})

	return [fetchResult]
}

export default useGetSeedTicketTypeList
